export const RESUME_DESCRIPTION_EDIT_MODAL_NAME = 'resumeDescriptionEdit';
